import type { BetterFetchOption } from '@better-fetch/fetch'
import type { BetterAuthClientPlugin } from 'better-auth/client'

import type { switchUserPlugin } from './server'

export const switchUserClientPlugin = () => {
  return {
    id: 'switch-user',
    $InferServerPlugin: {} as ReturnType<typeof switchUserPlugin>,
    getActions: ($fetch) => {
      return {
        switchUser: async (
          data: {
            userId: string
            /**
             * Organization to switch inside. Omit to use the caller's active
             * organization; pass it only for a child who belongs to both a school
             * and a family and is reaching the other one's roster.
             */
            organizationId?: string
            /**
             * In a family: the family PIN, required when switching into the parent
             * (`main`) profile. In a school: the target student's own login PIN,
             * always required.
             */
            pin?: string
            /** The parent's password. Used instead of the PIN when the family has none. */
            password?: string
          },
          fetchOptions?: BetterFetchOption,
        ) => {
          // Membership in the named organization is verified server-side; when it
          // is omitted the organization is resolved from the caller's session.
          return await $fetch('/switch-user', {
            method: 'POST',
            body: data,
            ...fetchOptions,
          })
        },
      }
    },
  } satisfies BetterAuthClientPlugin
}
